import { html, navigate } from 'onefold';

export function NotFoundPage(): Node {
  return html`
    <div>
      <h1>Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <button onclick=${() => navigate('/')} style="padding:8px 16px;border-radius:6px;border:1px solid var(--border);cursor:pointer;margin-top:12px">
        Go to Introduction
      </button>
    </div>
  `;
}
